module.exports = __webpack_public_path__ + "img/nkfe_nkfactorytkn.bc2a9ba.png";